import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class SanitizeService {
  sanitize(input: string): string {
    return input.replace(/<[^>]+>/g, '');
  }
}
